export const PropsType = {
    list:{
        type:Array,
        default:() => []
    },
    level:{
        type:Number,
        default:() => []
    },
    callBack: {
        type:Object,
        default:() => ({})
    },
    selected:{
        type: Number,
        default:() => undefined
    },
    haveExtraButton: {
        type: Boolean,
        default: false
    }
} 

export const ButtonType = function(callBack1, callBack2, callBack3) {
    return [
            {
                key:'edit',
                type:'ios-create',
                content:'编辑团队',
                callBack: callBack1,
            },
            {
                key:'add',
                type:'ios-add',
                content:'添加子团队',
                callBack: callBack2,
            },
            {
                key:'close',
                type:'ios-close',
                content:'废弃团队',
                callBack: callBack3,
            }
        ]
}